import { Accordion, Code, Stack, Text } from '@mantine/core';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import {
  formatSessionConfig,
  getSessionConfigRawJson,
} from './formatSessionConfig';

type SessionConfigSummaryProps = {
  session: DeviceConfigurationApi | null | undefined;
};

/** Debug-only readable session configuration summary. */
export function SessionConfigSummary({ session }: SessionConfigSummaryProps) {
  const rows = formatSessionConfig(session);
  const rawJson = getSessionConfigRawJson(session);

  if (rows.length === 0) return null;

  return (
    <Accordion variant='contained'>
      <Accordion.Item value='session-config-summary'>
        <Accordion.Control>
          <Text size='xs' fw={600} c='dimmed'>
            Configurazione (debug)
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Stack gap={6}>
            {rows.map(row => (
              <Stack key={`${row.label}-${row.value}`} gap={0}>
                <Text size='xs' c='dimmed'>
                  {row.label}
                </Text>
                <Text size='sm' style={{ wordBreak: 'break-word' }}>
                  {row.value}
                </Text>
              </Stack>
            ))}
            {rawJson ? (
              <Accordion variant='contained'>
                <Accordion.Item value='raw-json'>
                  <Accordion.Control>
                    <Text size='xs' c='dimmed'>
                      JSON grezzo
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Code block>{rawJson}</Code>
                  </Accordion.Panel>
                </Accordion.Item>
              </Accordion>
            ) : null}
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
